var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadMp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Head_MP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Head_MP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0989576,16.2572583 C24.0989576,14.661767 24.7918547,14.591618 24.349349,11.147069 C23.9068433,7.70252012 20.2832692,4.52159374 15.536892,4.52159374 C10.7905149,4.52159374 6.42421006,7.29053236 6.16577675,12.7756646 C5.90734345,18.2607969 9.0641607,20.7947213 9.57125301,22.2187871 C10.0783453,23.6428529 10.0831347,26.350351 9.29156735,27.9486234 C8.76385578,29.0141383 7.84078698,30.3645972 6.52236093,32 L21.4845027,32 C19.4682946,30.674887 18.4956294,29.5935856 18.5665072,28.7560958 C18.637385,27.918606 18.8168186,27.2796562 19.1048081,26.8392463 C19.5442772,26.4855614 20.2012257,26.3681727 21.0756536,26.4870803 C22.3872955,26.6654416 23.6073026,26.5127679 23.9068433,25.5360408 C24.0958147,24.9198528 23.4044924,23.7844195 23.9068433,23.4274445 C24.4091943,23.0704695 24.0989576,22.5555164 24.0989576,22.307072 C24.0989576,22.2091259 24.5,22.0293909 24.5,21.8294442 C24.5,21.7768904 24.449783,21.5292969 24.349349,21.0866637 C24.3515181,20.7655597 24.4495943,20.53296 24.6435778,20.3888647 C24.8869866,20.2410579 25.4702038,20.2169907 25.819796,19.5567877 C25.9665145,19.2797108 24.829314,17.8276731 24.0989576,16.2572583 Z",
    id: "background",
    fill: "#8596A1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "22.3180201 7.11741198 6.1507637 12.7397502 6.1507637 14.9533121 23.870299 9.1189431"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "24.5336051 12.6829978 24.4134695 11.035362 6.48293935 10.3571515 6.04583116 12.6829978"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground-copy",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "24.4134695 10.3571515 23.2366267 8.17525005 8.02521635 7.51333452 6.80703495 10.3571515"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "6.1507637 14.0458759 6.36511653 16 24.4134695 11.555211 24.0404197 9.36599553"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-31",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "8.4773891 7.51333452 9.73195446 6.17374357 21.0756536 6.17374357 22.9194832 7.96920403"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-24",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "16.9569848 4.52159374 22.1234832 26.4870803 19.8712866 26.4870803 14.1461667 4.52159374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-30",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "15.0105313 4.52159374 12.4837612 4.99218501 19.2356847 26.4870803 19.9669205 26.4870803"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadMp);
export default __webpack_public_path__ + "static/media/Head_MP.e41ee0d9131585fb5e3c6eecf6bb5869.svg";
export { ForwardRef as ReactComponent };